import { Box, Button, CircularProgress, Grid } from '@material-ui/core';
import { Field, Formik, Form } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';
import { IChangePassword } from '../../services/models/user';
import userService from '../../services/useCases/user';

import useCommonStyles, { blueButtonProps } from '../../styles/common';
import { snackbarUtils } from '../../utils';

const ValidationSchema = Yup.object().shape({
  email: Yup.string().required('Email é obrigatório'),
  password: Yup.string().required('Senha é obrigatória'),
  confirmPassword: Yup.string()
    .required('Confirmação de senha é obrigatória')
    .oneOf([Yup.ref('password'), null], 'Senhas diferentes'),
});

const initialValues: IChangePassword = {
  email: '',
  password: '',
  confirmPassword: '',
};

interface IChangePasswordProps {
  onSubmit?: () => void;
}

const ChangePassword = (props: IChangePasswordProps) => {
  const commonClasses = useCommonStyles();
  const handleSubmit = async (model: IChangePassword) => {
    try {

      await userService.changePassword(model);
      props.onSubmit && props.onSubmit();
    } catch (error) {
      snackbarUtils.error('Email em uso')

    }
  };

  return (
    <Box padding="10px" borderRadius="15px">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={ValidationSchema}
      >
        {({ isSubmitting, touched, errors }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field
                  name="email"
                  component={TextField}
                  type="email"
                  label="Email"
                  size="small"
                  error={!!touched.email && Boolean(errors.email)}
                  helperText={!!touched.email && errors.email}
                  InputProps={{
                    className: commonClasses.inputs,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="password"
                  component={TextField}
                  type="password"
                  label="Senha"
                  size="small"
                  error={!!touched.password && Boolean(errors.password)}
                  helperText={!!touched.password && errors.password}
                  InputProps={{
                    className: commonClasses.inputs,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="confirmPassword"
                  component={TextField}
                  type="password"
                  label="Confirmar Senha"
                  size="small"
                  error={
                    !!touched.confirmPassword && Boolean(errors.confirmPassword)
                  }
                  helperText={
                    !!touched.confirmPassword && errors.confirmPassword
                  }
                  InputProps={{
                    className: commonClasses.inputs,
                  }}
                />
              </Grid>
            </Grid>

            <Box marginTop={4} display="flex" justifyContent="center">
              <Button
                type="submit"
                startIcon={
                  isSubmitting ? <CircularProgress size="1rem" /> : null
                }
                disabled={isSubmitting}
                className={commonClasses.blueButton}
                {...blueButtonProps}
              >
                Salvar Alterações
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default ChangePassword;
